/**
 * Created by Administrador on 11/26/2019.
 */
(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('depotCtrl', depotCtrl);

    depotCtrl.$inject = ['cities', 'tabs', 'branchOfficeService', 'linkService',
        'userService','userSession', 'excelService','cargoReportService', 'subClassifications'];

    function depotCtrl(cities, tabs, branchOfficeService, linkService, userService,userSession,
                       excelService, cargoReportService, subClassifications){
        var vm = this;
        vm.tabs = tabs;
        vm.cityAll = [{name: 'Todas', initial: 'ALL'}];
        vm.userSession = userSession.data;
        vm.cities = cities;
        vm.destinyCities = cities;
        vm.subClassifications = [];
        vm.branchOffices = [];
        vm.isGeneralOrRegional = userService.isGeneralOrRegional(vm.userSession.positionType);
        vm.typeClients = [
            { "name": "Cliente Normal","code": "NORMAL"},
            { "name": "Cliente Corporativo","code": "CORPORATE"},
            { "name": "Todos","code": "ALL"}
        ]

        if(vm.userSession.positionType != "GENERAL_ADMIN"){
            vm.cities = getCities(vm.cities,vm.userSession);
        }

        vm.filterPassages = {
            branchOffice: null,
            detail: true
        };

        vm.isReport = false;

        getSubClassifications();

        vm.onChangeCleanReport = function () {
            vm.isReport = false;
        }

        vm.onChangeDetail = function () {
            vm.isReport = false;
            if(!vm.filterPassages.detail){
                vm.destinyCities = cities;
                vm.destinyCities = vm.cityAll.concat(vm.destinyCities);
            }else{
                vm.destinyCities = cities;
            }
        }

        vm.onChangeBranchOffice = function() {
            vm.isReport = false;
            var city = vm.filterPassages.originCity;
            if(city !== null && city !== undefined){
                vm.branchOffices = [];
                var cityId = linkService.getLinkId(city._links.self.href).split('_');
                branchOfficeService.getBranchOfficesByCityCargo(cityId[0])
                    .then(function (response) {
                        var res = (response.data._embedded) ? response.data._embedded.branchOffices : [];
                        vm.branchOffices = res;
                        if(vm.userSession.positionType == "COUNTER"){
                            vm.branchOffices = getBranchOffices(vm.branchOffices,vm.userSession._embedded.branchOffices);
                        }
                    });
            }
        }

        vm.generateDepot = function (isValid, formGenerateArching) {
            if(isValid){
                var originBranchOfficeId  = linkService.getLinkId(vm.filterPassages.originBranchOffice._links.self.href);
                var typeClient = vm.filterPassages.typeClient.code;
                var subClassificationId = (vm.filterPassages.priority.lang === 'Todos') ? 'ALL' : linkService.getLinkId(vm.filterPassages.priority._links.self.href);
                var cityId = "";
                if(vm.filterPassages.destinyCity.initial=='ALL'){

                }else{
                    cityId = linkService.getLinkId(vm.filterPassages.destinyCity._links.self.href).split('_');
                }
                var detail = vm.filterPassages.detail;

                cargoReportService.getCargoStockReport(originBranchOfficeId,typeClient,cityId[0],detail, subClassificationId).then(function (response) {
                    if(response !== undefined) {
                        vm.report = response.data;
                        if(vm.report.stockList.length>0){
                            vm.isReport = true;
                        }else{
                            vm.isReport = false;
                        }
                    } else {
                        vm.isReport = false;
                    }
                });
            }
        }

        vm.exportPdf = function(){
            var originBranchOfficeId  = linkService.getLinkId(vm.filterPassages.originBranchOffice._links.self.href);
            var typeClient = vm.filterPassages.typeClient.code;
            var cityId = "";
            var subClassificationId = (vm.filterPassages.priority.lang === 'Todos') ? 'ALL' : linkService.getLinkId(vm.filterPassages.priority._links.self.href);
            if(vm.filterPassages.destinyCity.initial=='ALL'){

            }else{
                cityId = linkService.getLinkId(vm.filterPassages.destinyCity._links.self.href).split('_');
            }
            var detail = vm.filterPassages.detail;
            cargoReportService.getCargoStockReportPdf(originBranchOfficeId,typeClient,cityId[0],detail, subClassificationId)
                .then(function (response) {
                    if(response == undefined){
                        vm.report = undefined;
                    }else{
                        var file = new Blob([response.data], {type: 'application/pdf;base64'});
                        var nameFile = "report_stock.pdf";
                        var date = moment().format('YYYY_MM_DD');

                        if (window.navigator && window.navigator.msSaveOrOpenBlob){
                            window.navigator.msSaveBlob(file, nameFile);
                        }else{
                            var fileURL = URL.createObjectURL(file);
                            var a = document.createElement('a');
                            a.href = fileURL;
                            a.target = '_blank';
                            a.download = nameFile;
                            document.body.appendChild(a);
                            a.click();
                        }
                    }
                });
        }

        vm.generateToExcel = function (contendId) {
            excelService.exportDataToExcel(contendId, vm.filterPassages.detail ? 'report_stock_detallado' : 'report_stock_resumen');
        }

        vm.cancelGenerateTraffic = function(formGenerateArching) {
            vm.filterPassages.typeClient = null;
            vm.filterPassages.originCity = null;
            vm.filterPassages.originBranchOffice = null;
            vm.filterPassages.destinyCity = null;
            vm.filterPassages.detail = true;
            vm.destinyCities = cities;
            vm.isReport = false;
        };

        function getSubClassifications() {
            vm.subClassifications = [];
            vm.subClassifications.push({lang: "Todos"});
            angular.forEach(subClassifications, function (subClassification) {
                vm.subClassifications.push(subClassification);
            });
        }

        function getCities(vCities,vUserSession){
            var citiesAux = [];

            angular.forEach(vCities, function (city) {
                var cityId = linkService.getLinkId(city._links.self.href).split('_');
                if(cityId[0]==vUserSession._embedded.branchOffice.cityId){
                    citiesAux.push(city);
                }
            });
            return citiesAux;
        }

        function getBranchOffices(vBranchOffices,vSessionBranchOffice){
            var branchOfficesAux = [];
            angular.forEach(vBranchOffices, function (branchOffice) {
                angular.forEach(vSessionBranchOffice, function (sessionBranchOffice) {
                    if(linkService.getLinkId(branchOffice._links.self.href)== linkService.getLinkId(sessionBranchOffice._links.self.href)){
                        branchOfficesAux.push(branchOffice);
                    }
                })
            })
            return branchOfficesAux;
        }
    }
})();
